import React, { FunctionComponent } from 'react';
import { SocialMediaIconTypes } from '../../../constants/Enums';
import { SocialMediaIcon } from '../../Partials/SocialMediaIcon/SocialMediaIcon';
import { ArticleModel } from '../../../services/content/article/models/ArticleModel';

type Props = {
    className?: string;
    article: ArticleModel;
};

export const SocialIcons: FunctionComponent<Props> = ({ article, className }) => {
    return (
        <div className={`${className ? className : ''} d-flex flex-row justify-content-between justify-content-md-end`}>
            {/*<SocialMediaIcon article={article} type={SocialMediaIconTypes.FACEBOOK} className='me-auto me-md-2'/>*/}
            <SocialMediaIcon article={article} type={SocialMediaIconTypes.MESSENGER} className='me-auto me-md-2' />
            <SocialMediaIcon article={article} type={SocialMediaIconTypes.WHATSAPP} className='me-auto me-md-2' />
            <SocialMediaIcon article={article} type={SocialMediaIconTypes.VIBER} className='me-auto me-md-2' />
            <SocialMediaIcon article={article} type={SocialMediaIconTypes.EMAIL} className='me-auto me-md-2' />
            <SocialMediaIcon article={article} type={SocialMediaIconTypes.CLIPBOARD} />
        </div>
    );
};
